module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Ga-Hb-Ia.43890c2d.png";